// tslint:disable-next-line
interface Array<T> {
	includes(searchElement: T, start?: number): boolean;
}

// tslint:disable-next-line
interface String {
	includes(searchElement: string, start?: number): boolean;
}

module YVR.Utilities.Polyfill {
	function main() {
		initArrayIncludesPolyfill();
		initIsArrayPolyfill();
		initObjectKeysPolyfill();
		initStringIncludesPolyfill();
	}


	/**
	 * Add the .includes() polyfill to arrays if the browser does not support it.
	 * Sourced from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
	 */
	function initArrayIncludesPolyfill() {
		if (!Array.prototype.includes) {
			Array.prototype.includes = function (searchElement: any, start = 0) {
				if (this == null) {
					throw new TypeError('Array.prototype.includes called on null or undefined');
				}

				const O = Object(this);
				const length = parseInt(O.length, 10) || 0;

				if (length === 0) {
					return false;
				}

				let k;

				if (start >= 0) {
					k = start;
				} else {
					k = length + start;

					if (k < 0) {
						k = 0;
					}
				}

				while (k < length) {
					let currentElement = O[k];

					if (searchElement === currentElement ||
						(searchElement !== searchElement && currentElement !== currentElement)) {
						return true;
					}

					k++;
				}

				return false;
			};
		}
	}


	/**
	 * Add the Array.isArray() polyfill.
	 * Sourced from: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
	 */
	function initIsArrayPolyfill() {
		if (!Array.isArray) {
			Array.isArray = (arg: any): arg is any[] => Object.prototype.toString.call(arg) === '[object Array]';
		}
	}


	/**
	 * Add the Object.keys() polyfill.
	 * Sourced from: http://stackoverflow.com/a/5675579
	 */
	function initObjectKeysPolyfill() {
		if (!Object.keys) {
			Object.keys = function (obj) {
				const keys = [];

				for (let k in obj) {
					if (Object.prototype.hasOwnProperty.call(obj, k)) {
						keys.push(k);
					}
				}

				return keys;
			};
		}
	}


	/**
	 * Add the .includes() polyfill to strings if the browser does not support it.
	 * Sourced from: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/includes
	 */
	function initStringIncludesPolyfill() {
		if (!String.prototype.includes) {
			String.prototype.includes = function (searchElement: string, start = 0) {
				if (this == null) {
					throw new TypeError('String.prototype.includes called on null or undefined');
				}

				if (start + searchElement.length > this.length) {
					return false;
				} else {
					return this.indexOf(searchElement, start) !== -1;
				}
			};
		}
	}


	main();
}
